import { axios } from "~/plugins/request"
export const state = () => {
  return {}
}
export const mutations = {}
export const actions = {
  initOrderList({ commit }, params) {
    return new Promise((resolve, reject) => {
      let orderList = axios.post('/order/findOrder', params)
      let orgTree = axios.get('/org/findOrgTreeByCurrentUser')
      Promise.all([orderList, orgTree]).then(res => {
        resolve(res)
      }).catch(error => {
        reject(error)
      })
    })
  },
  selectMyAgencyOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('order/selectMyAgencyOrder', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveOrderContract({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/order/saveOrderContract', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/order/saveOrder', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  deleteOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/order/orderDelete', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findOrderById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/order/findOrderById', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  approval({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/order/approveSalesOrderStart', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  seviceConfirm({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/service/updateServiceConfirm', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveSupplementOrder({ commit }, params) {     //pos详情保存
    return new Promise((resolve, reject) => {
      axios.post('order/saveSupplementOrder', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  contractLock({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('bestSign/contractLock', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  contractRemake({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('bestSign/contractUnLock', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  contractPreview({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('bestSign/contractView', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  cardNoBlur({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('student/findVoByCardNo', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  userPhoneBlur({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('student/findVoByPhone', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getBeforeProductChangeInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/productChange/findOldOrderByNewOrder', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAfterProductChangeInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/productChange/findNewOrderByOldOrder', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  changeCommiter({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/order/updateSubmitUser', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  contractDownLoad({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('bestSign/downloadContractStatus', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  exportOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        url: '/export/salesOrderList',
        data: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getRefundDetailInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get('/refund/findRefundableOrderByOrderId', { params }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  findRefundOrderListByOrderId({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get('/refund/findRefundOrderListByOrderId', { params }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  withdrawOrder({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/workflowApproval/workflowRecall', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getServiceType({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get('/order/getSubjectList', { params }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getProvince({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.get('/user/selProvinceList', { params }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getFileUrl({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'get',
        url: '/seafile/getPdfIo',
        params: params,
        responseType: 'blob',
        headers: {
          'Content-Type': 'application/json'
        }
      }).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  isAcademicAffairs({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/order/isAcademicAffairs', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  updateOrderSomeInfo({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios.post('/order/updateOrderSomeInfo', params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
}
